import {Box, Typography} from '@mui/material'
import React, {FC, ReactNode} from 'react'

const Section: FC<{
  title: string
  value?: ReactNode
}> = ({title, value}) => (
  <Box>
    <Typography data-testid="downtime-dashboard-stoppage-title" variant="caption">
      {title}
    </Typography>
    <Typography
      data-test-id="downtime-dashboard-stoppage-time-value"
      component="div"
      sx={{fontWeight: 500}}
    >
      {value ?? '-'}
    </Typography>
  </Box>
)

type StoppageTimeProps = {
  stoppedTime: string
  stoppagesCount?: string
  title: string
}

export const StoppageTime: FC<StoppageTimeProps> = ({stoppedTime, stoppagesCount, title}) => {
  const value = stoppagesCount ? `${stoppagesCount} (${stoppedTime} h)` : `${stoppedTime} h`

  return (
    <Box data-test-id={`downtime-dashboard-stoppage-time${stoppagesCount ? '-with-count' : ''}`}>
      <Section title={title} value={value} />
    </Box>
  )
}
